import { vuexEventPathGenerator } from '@/utils';
export const mutationType = {
    SET_OPEN_HISTORY_DIALOG: 'SET_OPEN_HISTORY_DIALOG',
    SET_SELECTED_HUB: 'SET_SELECTED_HUB',
    SET_SELECTED_STORE: 'SET_SELECTED_STORE',
    SET_FILTER_OPTION: 'SET_FILTER_OPTION',
    GET_OPERATION_SETTING_HISTORY_LIST: 'GET_OPERATION_SETTING_HISTORY_LIST',
    GET_HUB_LIST: 'GET_HUB_LIST',
    GET_STORE_LIST: 'GET_STORE_LIST',
    SET_IS_GETTING_HISTORY_ON_FETCHING: 'SET_IS_GETTING_HISTORY_ON_FETCHING',
    SET_IS_GETTING_HISTORY_ON_ERROR: 'SET_IS_GETTING_HISTORY_ON_ERROR',
    CLEAR_LIST: 'CLEAR_LIST',
};
export const operationSettingHistoryMutationType = vuexEventPathGenerator(mutationType, 'operationSettingHistory');
const mutations = {
    [mutationType.SET_OPEN_HISTORY_DIALOG](state, isOpen) {
        state.isDialogOpen = isOpen;
    },
    [mutationType.CLEAR_LIST](state) {
        state.list = [];
    },
    [mutationType.GET_OPERATION_SETTING_HISTORY_LIST](state, { list, paginationData, }) {
        state.list = list;
        state.paginationData = paginationData;
    },
    [mutationType.SET_SELECTED_HUB](state, hubId) {
        state.selectedHub = hubId;
    },
    [mutationType.SET_SELECTED_STORE](state, storeId) {
        state.selectedStore = storeId;
    },
    [mutationType.SET_FILTER_OPTION](state, payload) {
        Object.entries(payload).forEach(([key, value,]) => {
            state.filterOption[key] = value;
        });
    },
    [mutationType.GET_HUB_LIST](state, payload) {
        state.hubList = payload;
    },
    [mutationType.GET_STORE_LIST](state, payload) {
        state.storeList = payload;
    },
    [mutationType.SET_IS_GETTING_HISTORY_ON_FETCHING](state, isFetching) {
        state.isFetching = isFetching;
    },
    [mutationType.SET_IS_GETTING_HISTORY_ON_ERROR](state, isError) {
        state.isError = isError;
    },
};
export default mutations;
